import {
  CONSULTA_CENTRO_COSTO,
  CONSULTA_CUENTA,
  CONSULTA_TARJETA,
} from 'user/constants/Funcionalidad';

export const REPORT_MENU_PERMISSIONS = [
  CONSULTA_CUENTA,
  CONSULTA_CENTRO_COSTO,
  CONSULTA_TARJETA,
] as const;

export const REPORT_OPTION_PERMISSIONS: Record<string, readonly string[]> = {
  'ultimas-liquidaciones': [CONSULTA_CUENTA],
  'movimientos-por-tarjeta': [CONSULTA_TARJETA],
};

export function canAccessReportesMenu(funcionalidades: string[]): boolean {
  return REPORT_MENU_PERMISSIONS.some((permission) => funcionalidades.includes(permission));
}

export function canAccessReportOption(
  funcionalidades: string[],
  reportValue: string,
): boolean {
  const requiredPermissions = REPORT_OPTION_PERMISSIONS[reportValue];
  if (!requiredPermissions) {
    return true;
  }
  return requiredPermissions.some((permission) => funcionalidades.includes(permission));
}
